/**
 * Entra ID directory role template GUIDs used in GDAP relationships.
 * See Appendix C of the unified project plan.
 */
export const ENTRA_ROLES = {
    // Existing roles (15)
    GLOBAL_ADMIN: "62e90394-69f5-4237-9190-012177145e10",
    EXCHANGE_ADMIN: "29232cdf-9323-42fd-ade2-1d097af3e4de",
    SHAREPOINT_ADMIN: "f28a1f50-f6e7-4571-818b-6a12f2af6b6c",
    TEAMS_ADMIN: "69091246-20e8-4a56-aa4d-066075b2a7a8",
    INTUNE_ADMIN: "3a2c62db-5318-420d-8d74-23affee5d9d5",
    SECURITY_ADMIN: "194ae4cb-b126-40b2-bd5b-6091b380977d",
    COMPLIANCE_ADMIN: "ac434307-12b9-4fa1-a708-88bf58caabc1",
    USER_ADMIN: "fe930be7-5e62-47db-91af-98c3a49a38b1",
    HELPDESK_ADMIN: "729827e3-9c14-49f7-bb1b-9608f156bbb8",
    LICENSE_ADMIN: "4d6ac14f-3453-41d0-bead-e2824e8a4200",
    SERVICE_SUPPORT_ADMIN: "f023fd81-a637-4b56-95fd-791ac0226033",
    GLOBAL_READER: "f2ef992c-3afb-46b9-b7cf-a126ee74c451",
    SECURITY_READER: "5d6b6bb7-de71-4623-b4af-96380a352509",
    REPORTS_READER: "4a5d8f65-41da-4de4-8968-e035b65339cf",
    AUTHENTICATION_ADMIN: "c4e39bd9-1100-46d3-8c65-fb160da0071f",
    // V7 new roles (20) — verified against Microsoft Learn
    APPLICATION_ADMIN: "9b895d92-2cd3-44c7-9d02-a6ac2d5ea5c3",
    AUTH_POLICY_ADMIN: "0526716b-113d-4c15-b2c8-68e3c22b9f80",
    BILLING_ADMIN: "b0f54661-2d74-4c50-afa3-1ec803f12efe",
    CLOUD_APP_SECURITY_ADMIN: "892c5842-a9a6-463a-8041-72aa08ca3cf6",
    CLOUD_DEVICE_ADMIN: "7698a772-787b-4ac8-901f-60d6b08affd2",
    DOMAIN_NAME_ADMIN: "8329153b-31d0-4727-b945-745eb3bc5f31",
    PRIVILEGED_AUTH_ADMIN: "7be44c8a-adaf-4e2a-84d6-ab2649e08a13",
    PRIVILEGED_ROLE_ADMIN: "e8611ab8-c189-46e8-94e1-60213ab1f814",
    CONDITIONAL_ACCESS_ADMIN: "b1be1c3e-b65d-4f19-8427-f6fa0d97feb9",
    IDENTITY_GOVERNANCE_ADMIN: "45d8d3c5-c802-45c6-b32a-1d70b5e1e86e",
    HYBRID_IDENTITY_ADMIN: "8ac3fc64-6eca-42ea-9e69-59f4c7b60eb2",
    WINDOWS_365_ADMIN: "11451d60-acb2-45eb-a7d6-43d0f0125c13",
    POWER_PLATFORM_ADMIN: "11648597-926c-4cf3-9c36-bcebb0ba8dcc",
    ATTRIBUTE_DEFINITION_ADMIN: "8424c6f0-a189-499e-bbd0-26c1753c96d4",
    /** Renamed from Power BI Administrator by Microsoft */
    FABRIC_ADMIN: "a9ea8996-122f-4c74-9520-8edcd192826c",
    DYNAMICS_365_ADMIN: "44367163-eba1-44c3-98af-f5787879f96a",
    PRINTER_ADMIN: "644ef478-e28f-4e28-b9dc-3fdde9aa0b1f",
    OFFICE_APPS_ADMIN: "2b745bdf-0803-4d80-aa65-822c4493daac",
    DESKTOP_ANALYTICS_ADMIN: "38a96431-2bdf-4b4c-8b6e-5d3d8abac1a4",
    TEAMS_COMMS_SUPPORT_ENGINEER: "f70938a0-fc10-4177-9e90-2178f8765737",
    TEAMS_DEVICES_ADMIN: "3d762c5a-1b6c-493f-843e-55a3b42923d4",
    TEAMS_TELEPHONY_ADMIN: "aa38014f-0993-46e9-9b45-30501a20909d",
    PRINTER_TECHNICIAN: "e8cef6f1-e4bd-4ea8-bc07-4b8d950f4477",
    MESSAGE_CENTER_READER: "790c1fb9-7f7d-4f88-86a1-ef1f95c05c1b",
};
/**
 * Human-readable display names for each Entra role.
 */
export const ENTRA_ROLE_DISPLAY_NAMES = {
    // Existing (15)
    [ENTRA_ROLES.GLOBAL_ADMIN]: "Global Administrator",
    [ENTRA_ROLES.EXCHANGE_ADMIN]: "Exchange Administrator",
    [ENTRA_ROLES.SHAREPOINT_ADMIN]: "SharePoint Administrator",
    [ENTRA_ROLES.TEAMS_ADMIN]: "Teams Administrator",
    [ENTRA_ROLES.INTUNE_ADMIN]: "Intune Administrator",
    [ENTRA_ROLES.SECURITY_ADMIN]: "Security Administrator",
    [ENTRA_ROLES.COMPLIANCE_ADMIN]: "Compliance Administrator",
    [ENTRA_ROLES.USER_ADMIN]: "User Administrator",
    [ENTRA_ROLES.HELPDESK_ADMIN]: "Helpdesk Administrator",
    [ENTRA_ROLES.LICENSE_ADMIN]: "License Administrator",
    [ENTRA_ROLES.SERVICE_SUPPORT_ADMIN]: "Service Support Administrator",
    [ENTRA_ROLES.GLOBAL_READER]: "Global Reader",
    [ENTRA_ROLES.SECURITY_READER]: "Security Reader",
    [ENTRA_ROLES.REPORTS_READER]: "Reports Reader",
    [ENTRA_ROLES.AUTHENTICATION_ADMIN]: "Authentication Administrator",
    // V7 new (20)
    [ENTRA_ROLES.APPLICATION_ADMIN]: "Application Administrator",
    [ENTRA_ROLES.AUTH_POLICY_ADMIN]: "Authentication Policy Administrator",
    [ENTRA_ROLES.BILLING_ADMIN]: "Billing Administrator",
    [ENTRA_ROLES.CLOUD_APP_SECURITY_ADMIN]: "Cloud App Security Administrator",
    [ENTRA_ROLES.CLOUD_DEVICE_ADMIN]: "Cloud Device Administrator",
    [ENTRA_ROLES.DOMAIN_NAME_ADMIN]: "Domain Name Administrator",
    [ENTRA_ROLES.PRIVILEGED_AUTH_ADMIN]: "Privileged Authentication Administrator",
    [ENTRA_ROLES.PRIVILEGED_ROLE_ADMIN]: "Privileged Role Administrator",
    [ENTRA_ROLES.CONDITIONAL_ACCESS_ADMIN]: "Conditional Access Administrator",
    [ENTRA_ROLES.IDENTITY_GOVERNANCE_ADMIN]: "Identity Governance Administrator",
    [ENTRA_ROLES.HYBRID_IDENTITY_ADMIN]: "Hybrid Identity Administrator",
    [ENTRA_ROLES.WINDOWS_365_ADMIN]: "Windows 365 Administrator",
    [ENTRA_ROLES.POWER_PLATFORM_ADMIN]: "Power Platform Administrator",
    [ENTRA_ROLES.ATTRIBUTE_DEFINITION_ADMIN]: "Attribute Definition Administrator",
    [ENTRA_ROLES.FABRIC_ADMIN]: "Fabric Administrator",
    [ENTRA_ROLES.DYNAMICS_365_ADMIN]: "Dynamics 365 Administrator",
    [ENTRA_ROLES.PRINTER_ADMIN]: "Printer Administrator",
    [ENTRA_ROLES.OFFICE_APPS_ADMIN]: "Office Apps Administrator",
    [ENTRA_ROLES.DESKTOP_ANALYTICS_ADMIN]: "Desktop Analytics Administrator",
    [ENTRA_ROLES.TEAMS_COMMS_SUPPORT_ENGINEER]: "Teams Communications Support Engineer",
    [ENTRA_ROLES.TEAMS_DEVICES_ADMIN]: "Teams Devices Administrator",
    [ENTRA_ROLES.TEAMS_TELEPHONY_ADMIN]: "Teams Telephony Administrator",
    [ENTRA_ROLES.PRINTER_TECHNICIAN]: "Printer Technician",
    [ENTRA_ROLES.MESSAGE_CENTER_READER]: "Message Center Reader",
};
//# sourceMappingURL=roles.js.map